import { render, staticRenderFns } from "./identification-page.vue?vue&type=template&id=8375412e"
import script from "./identification-page.vue?vue&type=script&lang=js"
export * from "./identification-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports